<template>
  <div class="min-h-screen">
        <PageHeader :title="props.title" :showBack="props.showBack" @back="handleBack">
            <slot name="headerActions"></slot>
        </PageHeader>
        <div class="min-h-screen mt-4">
            <div class="container mx-auto md:p-4 flex flex-col lg:flex-row w-full gap-4 transition-all min-h-full">
                <div class="container flex flex-col gap-4">
                    <div class="grid grid-cols-12 gap-4 transition-all duration-300">
                        <div class="col-span-12" :class="[props.mainFormClass]">
                            <slot name="mainForm" />
                        </div>
                        <slot name="sideComponent" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
    import { defineProps, defineEmits, getCurrentInstance } from 'vue';
    import PageHeader from '@/components/common/PageHeader.vue';
    import { useRouter } from 'vue-router';

    const props = defineProps({
        title: {
            type: String,
            required: true
        },
        mainFormClass: {
            type: String,
            required: false
        },
        showBack: {
            type: Boolean,
            default: true
        }
    })

    const emit = defineEmits(['back']);
    const router = useRouter();
    const instance = getCurrentInstance();

    const handleBack = () => {
        const hasBackListener = instance?.vnode?.props?.onBack;
        if (hasBackListener) {
            emit('back');
        } else {
            router.back();
        }
    }
</script>